import { Text, Img } from "../../components";
import React from "react";

export default function CaseStudySection() {
  return (
    <>
      {/* case study section */}
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center px-14 lg:px-5 md:px-5">
          <div className="relative h-[196px] lg:h-auto md:mr-0 md:h-auto">
            <Text className="w-full text-[13px] font-normal leading-[19px] !text-black-900_01">
              <>
                A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to
                evaluate their operation in detail. Virtually every action and decision that take place in a restaurant
                is eventually reflected on the P&L.
                <br />
                <br />
                While knowing the numbers on your P&L is important, the real value is understanding the actions and
                decisions that caused those numbers to be what they are. When the numbers are analyzed and tied back to
                specific actions in the restaurant, operational changes can be made and better results can be
                achieved.Buy <br />
                <br />
                The P&L Trend Analysis Worksheet is a tool that will dramatically enhance your ability to analyze and
                understand what&#39;s REALLY going on in your restaurant and how its affecting your profitability and
                success.
                <br />
                To learn more about your financial statements, please read some of the resources below:
                <br />A Profit and Loss Statement is one of the most important financial tools that a restaurant owner
                has to evaluate their operation in detail. Virtually every action and decision that take place in a
                restaurant is eventually reflected on the P&L.
                <br />
                <br />
                While knowing the numbers on your P&L is important, the real value is understanding the actions and
                decisions that caused those numbers to be what they are. When the numbers are analyzed and tied back to
                specific actions in the restaurant, operational changes can be made and better results can be
                achieved.Buy <br />
                <br />
                {/* The P&L Trend Analysis Worksheet is a tool that will dramatically enhance your ability to analyze and
                understand what&#39;s REALLY going on in your restaurant and how its affecting your profitability and
                success.
                <br />
                To learn more about your financial statements, please read some of the resources below: */}
              </>
            </Text>
            <div className="absolute bottom-0 left-0 right-0 top-0 m-auto h-[500px] flex-1 rounded-[10px] bg-gradient1 sm:min-h-[495px]" />
          </div>
          <div className="flex w-[26%] flex-col items-start gap-2 rounded-lg border border-solid border-gray-100 bg-white-a700 p-3 lg:w-full md:w-full">
            <Text size="text2xl" as="p" className="text-[16px] font-normal !text-orange-900 lg:text-[13px]">
              Purchase the Case Study to gain:
            </Text>
            <div className="mb-3.5 flex flex-col gap-1.5 self-stretch">
              <div className="flex items-center gap-[9px]">
                <Img src="images/img_signal_orange_500.svg" alt="Signal" className="h-[18px]" />
                <Text size="textlg" as="p" className="text-[14px] font-normal !text-black-900_01">
                  Achieve your personal and professional goal
                </Text>
              </div>
              <div className="flex items-center gap-[9px]">
                <Img src="images/img_signal_orange_500.svg" alt="Signal" className="h-[18px] self-end" />
                <Text size="textlg" as="p" className="text-[14px] font-normal !text-black-900_01">
                  Download all Templates
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
